function getLngLatFromPoint(point: any): [number, number] | null {
  const lng = Number(point?.longitude ?? point?.lng);
  const lat = Number(point?.latitude ?? point?.lat);

  if (!Number.isFinite(lng) || !Number.isFinite(lat)) {
    return null;
  }

  return [lng, lat];
}

export function getCumulativeDistanceData(
  points: any[],
  AMap: any,
  unit: "m" | "km"
) {
  if (!Array.isArray(points) || points.length === 0 || !AMap?.GeometryUtil) {
    return [];
  }

  const axisData: number[] = [];
  let cumulativeDistanceInMeters = 0;

  points.forEach((point, index) => {
    if (index === 0) {
      axisData.push(0);
      return;
    }

    const previous = getLngLatFromPoint(points[index - 1]);
    const current = getLngLatFromPoint(point);

    if (!previous || !current) {
      const axisValue =
        unit === "m"
          ? cumulativeDistanceInMeters
          : cumulativeDistanceInMeters / 1000;
      axisData.push(Math.round(axisValue * 10000) / 10000);
      return;
    }

    const segmentDistanceInMeters = AMap.GeometryUtil.distance(previous, current);
    if (Number.isFinite(segmentDistanceInMeters) && segmentDistanceInMeters > 0) {
      cumulativeDistanceInMeters += segmentDistanceInMeters;
    }

    const axisValue =
      unit === "m"
        ? cumulativeDistanceInMeters
        : cumulativeDistanceInMeters / 1000;

    axisData.push(Math.round(axisValue * 10000) / 10000);
  });

  return axisData;
}
